<template>
    <div class="form_item form_item-file form_item-file-new" @dragover="dragover" @dragleave="dragleave" @drop="drop">
        <div class="form_item-file_left" v-if="! selected" @click.prevent="selectFile">
            <p class="form_item-file_title" v-text="label"></p>
            <p class="form_item-file_date" v-html="tip"></p>
            <p class="form_item-file_drag" v-text="dragDescr"></p>
        </div>
        <div class="form_item-file_left" v-else>
            <p class="form_item-file_title" v-text="selected.name"></p>
        </div>
        <div class="form_item-file_right" @click.prevent="selectFile">
            <figure>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 14C1 14.7956 1.31607 15.5587 1.87868 16.1213C2.44129 16.6839 3.20435 17 4 17H14C14.7956 17 15.5587 16.6839 16.1213 16.1213C16.6839 15.5587 17 14.7956 17 14M13 9L9 13M9 13L5 9M9 13V1" stroke="#B2B3BC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </figure>
        </div>
        <input ref="fileInput"
               name="file"
               type="file"
               accept=".png, .jpg, .jpeg, .pdf, .CADES, .xls, .word, .p7s"
               hidden
               @input="pickFile" />
    </div>
</template>

<script>
export default {
    name: "FileUploadComponent",

    props: ['label', 'tip'],

    data: function () {
        return {
            selected: null,
        };
    },

    computed: {
        dragDescr: function () {
            if(location.pathname.indexOf('/en') === 0) {
                return '*Click on this area or drag and drop the desired file here';
            }

            return '*Натисніть на цю область, або перетягніть сюди потрібний файл';
        }
    },

    mounted() {
        this.$refs.fileInput.addEventListener('clear', () => this.selected = null);
    },

    destroyed() {
        this.$refs.fileInput.removeEventListener('clear');
    },

    methods: {
        dragover(event) {
            event.preventDefault();
            if (!event.currentTarget.classList.contains('active-drag')) {
                event.currentTarget.classList.add('active-drag');
            }
        },
        dragleave(event) {
            event.currentTarget.classList.remove('active-drag');
            },
        drop(event) {
            event.preventDefault();
            this.$refs.fileInput.files = event.dataTransfer.files;
            this.pickFile();
            event.currentTarget.classList.remove('active-drag');
        },
        selectFile() {
            this.$refs.fileInput.click()
        },

        pickFile () {
            let input = this.$refs.fileInput
            let file = input.files

            if (file && file[0]) {
                this.selected = file[0];

                this.$emit('input', file[0])
            }
        }
    }
}
</script>

<style scoped>
    .active-drag{
        background-color: #e5f4ff;
        border-color: #0096E0;
    }
</style>
